import React, { PropsWithChildren, useContext, useMemo, useReducer, useState } from 'react';

type HomeOnboardingContext = {
    markAsDone?(id: string): void;
    doneStepsIDs: Set<string>;
    activeStep: {
        campaign: number;
        addContact: number;
    };
    setActiveStep: any;
};

export type StepCategories = keyof HomeOnboardingContext['activeStep'];

export const HomeOnboardingContext = React.createContext<HomeOnboardingContext>(null);

export const useHomeOnboardingContext = (): HomeOnboardingContext => {
    const context = useContext(HomeOnboardingContext);
    if (!context) {
        console.error('context not found. Used outsiede of the provider. ');
        return null;
    }
    return context;
};

const reducer = (state: Set<string>, action: { type: string; value: string }) => {
    const updatedState = new Set(state);
    const availableActions = {
        add: () => updatedState.add(action.value),
        remove: () => updatedState.delete(action.value),
    };
    availableActions[action.type]();
    return updatedState;
};

export const HomeOnboardingProvider = ({ children }: PropsWithChildren<any>) => {
    const [doneStepsIDs, setDoneStepsIDs] = useReducer(reducer, new Set<string>());
    const [activeStep, setActiveStep] = useState({ campaign: null, addContact: null });
    const markAsDone = (id: string) => {
        setDoneStepsIDs({ type: 'add', value: id });
    };

    const value = useMemo(
        () => ({
            markAsDone,
            doneStepsIDs,
            activeStep,
            setActiveStep,
        }),
        [doneStepsIDs.size]
    );

    return <HomeOnboardingContext.Provider value={value}>{children}</HomeOnboardingContext.Provider>;
};
